import React from 'react'
import { Link } from 'react-router-dom'

const Services = () => {
    return (
        <>
            <div className="bGround py-auto md:py-[2rem] py-0 pb-10 lg:py-[8rem]">

                <div class="grid grid-cols-1 mx-auto lg:mx-[5.5rem] sm:grid-cols-2 md:grid-cols-3 lg:gap-8 gap-5 px-6 lg:px-8 md:px-14">
                   
                    <div class="lg:w-[82%] w-full">
                        <div className=" py-7 "><h1 className='text-white    font-black uppercase text-[11px] tracking-wider '>Our services</h1></div>
                        <div className=" border-b-[.4rem] border-b-[#B5D1B3] mt-[-1rem] w-[3.6rem]  "></div>
                        <div className="py-2  mt-5 md:py-2 lg:py-4"><h1 className='text-white text-3xl md:text-[2rem] lg:text-[2.5rem] font-black'>Valuations</h1></div>
                        <div className="">
                            <h1 className='text-white   lg:text-2xl tracking-wide font-black md:font-bold   lg:py-2 leading-8'>
                                Our fully accredited
                                valuers offer informed,
                                high quality valuation
                                advice for corporate and
                                private agribusiness
                                clients.</h1>
                        </div>

                        <div className="flex mt-4   py-2 ">
                            <button className='border text-[.8rem] text-center border-[white] py-3 text-[white] hover:text-[#004A8B] hover:bg-[white] px-9  '><Link to='/OurServices'>
                            FIND OUT MORE</Link></button>
                        </div>
                    </div>

                    <div class="lg:mr-[2rem] lg:w-[80%] w-full">
                        <div className="py-7 "><h1 className='text-white font-black uppercase text-[11px] tracking-wider '>Our services</h1></div>
                        <div className=" border-b-[.4rem] border-b-[#B5D1B3] mt-[-1rem] w-[3.6rem] "></div>
                        <div className="py-2 mt-5 md:py-2 lg:py-4"><h1 className='text-white text-3xl md:text-[2rem] lg:text-[2.5rem] font-black'>Transactions</h1></div>
                        <div className="">
                            <h1 className='text-white lg:text-2xl tracking-wide font-black md:font-bold lg:py-2 leading-8'>
                                Our collaborative
                                market leading team
                                provides a value-add
                                service with a proven
                                track record of
                                maximising proceeds.</h1>
                        </div>

                        <div className="flex mt-4  py-2 ">
                            <button className='border text-[.8rem] text-center border-[white] py-3 text-[white] hover:text-[#004A8B] hover:bg-[white]  px-9'><Link to='/TranServices'>FIND OUT MORE</Link></button>
                        </div>
                    </div>

                    <div class="lg:w-[80%] w-full">
                        <div className="py-7 "><h1 className='text-white font-black uppercase text-[11px] tracking-wider'>Our services</h1></div>
                        <div className=" border-b-[.4rem] border-b-[#B5D1B3] mt-[-1rem] w-[3.6rem]"></div>
                        <div className="py-2 mt-5 md:py-2 lg:py-4"><h1 className='text-white text-3xl md:text-[2rem] lg:text-[2.5rem] font-black'>Advisory</h1></div>
                        <div className="">
                            <h1 className='text-white lg:text-2xl tracking-wide font-black md:font-bold lg:py-2 leading-8'>
                                Our experienced
                                advisory team offers
                                strategic consultancy
                                advice on Land,
                                Agriculture, Water and
                                Development..</h1>
                        </div>


                        <div className="flex mt-4 py-2 ">
                            <button className='border text-[.8rem] text-center border-[white] py-3 text-[white] hover:text-[#004A8B] hover:bg-[white] px-9'><Link to='/AdServices'>FIND OUT MORE</Link></button>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Services